import { AuthProvider } from 'pages/AuthContext'; // Import your AuthProvider
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/color.css';
import './styles/font.css';
import './styles/index.css';
import './styles/tailwind.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppProvider } from 'Contexts/AppContext';

// window.addEventListener('error', (event) => {
//   if (event.message.includes('ResizeObserver loop')) {
//     console.log("event", event.message)
//     event.stopImmediatePropagation();
//   }
// });

const queryClient = new QueryClient()
ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <AppProvider>
        <App />
      </AppProvider>
    </AuthProvider>
  </QueryClientProvider >,
  document.getElementById('root')
);
